
export default {
  props: {
    value: {
      type: Number,
      required: true,
    },
    currencyCode: {
      type: String,
      default: 'USD',
    },
    locale: {
      type: String,
      default: 'en',
    },
    hideSubunits: {
      type: Boolean,
      default: false,
    },
    subunitsValue: {
      type: Boolean,
      default: false,
    },
    subunitsToUnit: {
      type: Number,
      default: 1,
    },
    supplementalPrecision: {
      type: Number,
      default: 0,
    },
  },
}
